import { TYPE, cannotGo, canOnlyGo, is_risk_type } from "./network/network_api";
import Risk from "./risk";
import UI from './ui';
import RouletteDriver from "./roulette_driver";
import RouletteScene from 'roulette'
import Jackpot from "./jackpot_driver";
import { REQUEST_TYPE } from "./network/net";
import Slot from "./slot";
import Balance from "./balance";
import Autoplay from "./autoplay";
import Help from "./help";
import Stream from "./frp/stream";
import Bonus from "./bonus";
import ProgressiveJackpot from "progressive_jackpot/progressive_jackpot"
import SETTINGS from 'settings'
import JackpotScene from 'jackpot_scene' 

/** Glues all the game drivers together so making it the uppermost driver.
 * @param leaves Object of views/interactives to pass to specific drivers. Moved away from drivers into some upper code to make implementation of automatic tests possible.
 */
export default function(
    space,
    leaves,
    mathConfig,
    bonusSettings,
    spec
)
{
    space.s( "state" )
        .take( 1 )
        .on( state => state.server.ready_to_play() )
    space.s( "request" )
        .take( 1 )
        .with( space.s( "state" ), ( _, state ) => state )
        .on( state => state.server.first_request() )
    
    const $state = space.s( "state" );
    load( space )
    
    const $request = space.s( "request" );
    const $pending = space.s( "pending", undefined, true );
    const $error = space.s( "error" );

    $pending
        .any( $state, ( pending, state ) => ({ pending, state }) )
        .map( ({ pending, state }) =>
            canOnlyGo( TYPE.FINAL, state )
            &&
            ( pending !== undefined && pending != REQUEST_TYPE.ENTER_RISK )
        )
        .to( space.s( 'collecting' ) )
    
    $error
        .map( () => true )
        .to( space.s( "isError", false ) );
    
    $state.on( s =>
        s.state.debug_info && s.state.debug_info.game_scenario && s.state.debug_info.game_stage_id
        ?
        console.log( window.location.href.split( "?" )[ 0 ] + "?scenario=" + s.state.debug_info.game_scenario.original_index + "&stage=" + s.state.debug_info.game_stage_id.idx + "&lines=" + s.state.debug_info.game_scenario.line_id + "&bet=" + s.state.multiplier )
        :
        undefined
    );
    
    const balance = Balance( space, $state );
    balance.s( "winFlow" ).to( leaves.ui.space.s( "win" ) );
    
    //RISK:
    const risk = Risk(
        space,
        leaves.risk,
        spec.risks
    );
    
    //UI:
    const ui = UI(
        space,
        balance.s( "credits" ),
        mathConfig,
        leaves.ui.space,
    );
    Help( leaves.ui.space, leaves.help );
    leaves.ui.space.s( "collect" )
        .map( () => ({ type : REQUEST_TYPE.PROCEED }) )
        .to( $request );
    
    const slot = Slot(
        space,
        ui,
        leaves,
        spec
    );
    leaves.slot.space.glue( "winFlowUp", balance );
    leaves.freegames.space.glue( "winFlowUp", balance );
    const $winFlowCompleteSlot = leaves.slot.space.s( "winFlowComplete" );
    // нигде не используется пока что
    //const $winFlowCompleteFreegames = leaves.freegames.space.s( "winFlowComplete" );
    balance.s( "winFlowComplete" )
        .with( $state, ( complete, state ) => ({ complete, state }) )
        .on( ({ complete, state }) =>
        {
            $winFlowCompleteSlot.next(complete);
            //$winFlowCompleteFreegames.next(complete);
        } );
    money_up_sound( space, leaves, balance )
    slot.space.s( "displayingWin" ).to( leaves.ui.space.s( "displayingWin" ) );
    
    slot.barrel.s( "initiate" )
        .withLatestFrom( $state, ( i, state ) => state.type )
        .filter( type => type == TYPE.FINAL )
        .withLatestFrom( leaves.ui.space.s( "price" ), ( i, price ) => price )
        .map( price => - price )
        .subscribe( balance.s( "creditsChange" ) );
    
    leaves.ui.space.s( "gamble" )
        .map( () => ({ type : REQUEST_TYPE.ENTER_RISK }) )
        .subscribe( $request );
    
    space.s( "jackpot:isIn" ).to( space.s( "ui:isJackpot" ) )
    space.s( "jackpot:isIn" ).next( false )

    const states = postponed_states()
    handle_loaded_state( space, states, leaves )
    
    const autoplay = Autoplay(
        $request,
        $error,
        leaves.ui.space,
        slot.space.s( "winningRegularStop" ),
        space,
    );
    autoplay.glue( "initiate", slot.barrel );
    
    Bonus(
        space,
        leaves,
        bonusSettings
    );
    
    //start feature invitation:
    $state
        .map( () => false )
        .merge( $pending.map( () => false ) )
        .merge( slot.space.s( "barrelStop" ).map( state =>
            state.type == TYPE.REGULAR
            &&
            cannotGo( TYPE.FINAL, state.state ) )
        )
        .distinctUntilChanged()
        .subscribe( leaves.ui.space.s( "canStartFeature" ) );
    
    //risk invitation:
    $state
        .map( state => state.type == TYPE.FINISH )
        .merge( slot.space.s( "barrelStop" ).withLatestFrom(
            $state.map( state =>
                //in some games barrelStop event thrown AFTER game switches to FINISH state:
                state.type == TYPE.FINISH
                ||
                (
                    //no matter after regular spin or bonus:
                    state.state.stage.win > 0 &&
                    //risk doesn't count as state you can go (it's a separate scenario), so if no bonuses available (after regular spin without bonuses won or after bonuses):
                    canOnlyGo( TYPE.FINAL, state.state )
                )
            ),
            ( stop, mappedState ) => mappedState
        ) )
        //any server interaction cancels invitation:
        .merge( $pending
            .filter( pending => pending != undefined )
            .map( () => false )
        )
        .distinctUntilChanged()
        .subscribe( leaves.ui.space.s( "riskInvitation" ) );
    
    when_interactive( space )
    
    collect_button( space )
    
    //SPIN button is pretty complicated because it hides network "COLLECT" operation:
    $pending
        .any(
            $state,
            leaves.ui.space.s( "canBet" ),
            ( pending, state, canBet ) =>
                canBet
                ||
                (
                    canOnlyGo( TYPE.FINAL, state )
                    &&
                    _.includes( [ REQUEST_TYPE.PROCEED, REQUEST_TYPE.TAKE_WIN ], pending )
                    &&
                    ! is_risk_type( state.type )
                )
        )
        .to( leaves.ui.space.s( "spinVisible" ) );
    
    risk.s( "animating" )
        .combineLatest(
            slot.space.s( "animating" ),
            space.s( 'roulette:animating' ),
            space.s( "jackpot:flowing" ),
        )
        .map( merge => _.some( merge ) )
        .subscribe( space.s( "animating", false ) );
    
    $state
        .any( space.s( "isRisk" ), ( state, isRisk ) => ({ state, isRisk }) )
        .filter( ({ state, isRisk }) => state.type == TYPE.FINAL && ! isRisk )
        .map( ({ state }) => state )
        .to( slot.space.s( "readyToSpin" ) );
};

function money_up_sound( space, leaves, balance )
{
    //last 2 unique server states:
    const state_pair = []
    balance.s( "money" )
        .distinctUntilChanged()
        .pairwise()
        //ignore JACKPOT collect:
        .with(
            space.s( "state" ).map( state => {
                if ( state_pair[ state_pair.length - 1 ] != state.type ||  state_pair[ state_pair.length - 2 ] != state.type)
                {
                    state_pair.push( state.type )
                }
                while ( state_pair.length > 2 ) state_pair.shift()
            } ),
            ( pair, _ ) => pair )
        .filter( () =>
            state_pair[ 1 ] != TYPE.JACKPOT
            &&
            state_pair[ 1 ] != TYPE.REGULAR
            //uncomment if you DO NOT want progressive jackpot enter to play coins sound:
            /*&&
            state_pair[ 1 ] != TYPE.PROGRESSIVE_JACKPOT*/
            //from progressive jackpot to progressive jackpot:
            &&
            (
                state_pair[ 0 ] != TYPE.PROGRESSIVE_JACKPOT
                ||
                state_pair[ 1 ] != TYPE.PROGRESSIVE_JACKPOT
            )
            //from progressive jackpot to FINAL:
            &&
            (
                state_pair[ 0 ] != TYPE.PROGRESSIVE_JACKPOT
                ||
                state_pair[ 1 ] != TYPE.FINAL
            )
        )
        .filter( pair => pair[ 1 ] > pair[ 0 ] )
        .to( space.s( 'slot:money_up_sound' ) )
    
    space.s( 'slot:money_up_sound' )
        .on( () => {
            if ( leaves.slot.slotScene.sndCredits )
            {
                leaves.slot.slotScene.sndCredits.play()
            }
        } )
}

function collect_button( space )
{
    //enabled:
    space.s( "ui:enabled" )
        .any(
            space.s( "jackpot:isIn" ),
            space.s( "animating" ),
            space.s( "state" ),
            ( enabled, isJackpot, animating, state ) => enabled || ( isJackpot && ! animating ) || state.type == TYPE.PROGRESSIVE_JACKPOT
        )
        .to( space.s( "ui:collectEnabled" ) )
    
    //visible:
    space.s( "ui:riskInvitation" )
        .any(
            space.s( "isRisk" ),
            space.s( "ui:mayStop" ),
            space.s( "ui:spinVisible" ),
            space.s( "state" ),
            space.s( 'pending' ),
            ( invitation, isRisk, mayStop, spinVisible, state, pending ) =>
                (
                    invitation
                    ||
                    isRisk
                )
                &&
                ! mayStop
                &&
                ! spinVisible
                ||
                pending == REQUEST_TYPE.ENTER_RISK
                ||
                state.type == TYPE.PROGRESSIVE_JACKPOT
        )
        .to( space.s( "ui:collectVisible" ) )
}

function postponed_states()
{
    return [
        {
            type : TYPE.PRECURSOR,
            code : ( leaves, space ) => {
                const roulette = new RouletteScene( space )
                leaves.roulette.addChild( roulette )
                RouletteDriver(
                    space.s( 'state' ),
                    space.s( 'request' ),
                    roulette,
                    space.s( 'ui:startKey' ),
                    space,
                )
                space.s( 'roulette:start' ).to( space.s( 'ui:startImpulse' ) )
            }
        },
        {
            type : TYPE.JACKPOT,
            code : ( leaves, space ) => {
                const jackpot = new JackpotScene( SETTINGS.screen, space )
                leaves.jackpot.addChild( jackpot )
                Jackpot(
                    space.s( 'state' ),
                    space.s( 'request' ),
                    jackpot,
                    space.s( "ui:start" ),
                    space.s( "lastRequest" ),
                    space,
                )
            }
        },
        {
            type : TYPE.PROGRESSIVE_JACKPOT,
            code : ( leaves, space ) => {
                ProgressiveJackpot( space, leaves.progressive_jackpot )
            }
        }
    ]
}
function handle_loaded_state( space, states, leaves )
{
    //for every already preloaded state just call it's code:
    for ( const ti in TYPE ) {
        const type = TYPE[ ti ]
        if ( ! SETTINGS.bundles.some( b => ! b.loaded && b.types.some( t => t == type ) ) ) {
            execute_loaded_state( type, states, space, leaves )
        }
    }

    space.s( 'load:state' )
        .desc( 'the state which postponed because it had some bundles requirements' )
        .do( state => execute_loaded_state( state.type, states, space, leaves ) )
        //may be delayed later on ...
        .to( space.s( 'state' ) )
}
function execute_loaded_state( type, states, space, leaves )
{
    for ( const s of states ) {
        if ( s.type == type && ! s.loaded ) {
            console.log( 'Initializing bundled state', type, '...' )
            s.loaded = true
            s.code( leaves, space )
        }
    }
}

function load( space )
{
    //intended to do an array here but let's just handle the last state - engine is supposed to work at replication mode anyway:
    let pending_state = undefined

    SETTINGS.bundles = SETTINGS.bundles || []

    const $states = space.s( "net" )
        .map( net => {
            const state = net.state
            let reqs = []
            for ( const b of SETTINGS.bundles ) {
                if ( b.types.some( t => t == state.type ) && ! b.loaded ) {
                    reqs.push( b )
                }
            }
            return {
                reqs,
                state,
            }
        } )
    
    $states
        .filter( s => s.reqs.length <= 0 )
        .map( s => s.state )
        .to( space.s( 'state' ) )
    
    $states
        .filter( s => s.reqs.length > 0 )
        .do( s => pending_state = s.state )
        .map( s => s.reqs )
        .do( r => console.log( 'Loading', r, 'resources for current state ...' ) )
        .to( space.s( 'load:load' ) )
    
    space.s( 'load:complete' )
        .map( () => {
            if ( ! pending_state ) return

            //not all required bundles yet loaded:
            if ( ! reqs_met( pending_state.type ) ) return

            const s = pending_state
            pending_state = undefined
            return s
        } )
        .filter( s => s )
        .to( space.s( 'load:state' ) )
}
function reqs_met( type )
{
    //every required bundle must be already loaded:
    for ( const b of SETTINGS.bundles ) {
        if ( b.types.some( t => t == type ) && ! b.loaded ) {
             return false
        }
    }
    return true
}

function when_interactive( space )
{
    //false when the whole user interface must be disabled (become non-interactive with respectful visible representation), true otherwise:
    Stream.combineLatest(
        space.s( 'pending' ),
        space.s( 'slot:rotating' ),
        space.s( 'risk:choosingCard' ),
        space.s( "jackpot:isIn" ),
        space.s( "isError" ),
        //true when there is some animation going on which cannot be cancelled or intervened in any way:
        space.s( "animating" ),
    )
    .map( merge => _.every( merge, value => ! value ) )
    .any(
        space.s( 'load:loading' ),
        ( e, l ) => e && ( ! l || ! l.bundle )
    )
    .to( space.s( 'ui:enabled' ) )

    space.s( "isError" )
    .any(
        space.s( 'load:loading' ),
        ( e, l ) => ! e && ( ! l || ! l.bundle )
    )
    .to( space.s( 'interactive' ) )

    //block the whole keyboard when UI is also globally disabled:
    space.s( 'raw_keyboard' )
        .with( space.s( 'interactive' ), ( k, i ) => ({ k, i }) )
        .filter( ({ i }) => i )
        .map( ({ k }) => k )
        .to( space.s( 'keyboard' ) )
}





// WEBPACK FOOTER //
// ./src/library/game.es6